/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lock': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.266 8.472v-3.18a3.958 3.958 0 117.916 0v3.18h1.558c.927 0 1.679.752 1.679 1.68v6.835a1.68 1.68 0 01-1.68 1.68H4.347a1.68 1.68 0 01-1.68-1.68v-6.835c0-.928.752-1.68 1.68-1.68h1.92zm6.836 0v-3.18a2.878 2.878 0 00-5.755 0v3.18h5.755zm2.638 9.115a.6.6 0 00.6-.6v-6.835a.6.6 0 00-.6-.6H4.346a.6.6 0 00-.6.6v6.835c0 .33.27.6.6.6H15.74z" _fill="#1D3861"/>'
  }
})
